(function () {
  const root = document.querySelector('[data-signature-review-page]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const manualLinks = window.SignatureManualReviewProductLinks || {};
  const reviews = (window.SignatureReviewPageData || []).map(review => {
    const manual = manualLinks[review.id];
    if (!manual) return review;
    return {
      ...review,
      product: manual.productName || review.product,
      productUrl: manual.productUrl || review.productUrl
    };
  });
  const featuredWall = root.querySelector('#featured-wall');
  const grid = root.querySelector('#review-grid');
  const empty = root.querySelector('#empty-state');
  const loadMore = root.querySelector('#load-more');
  const resultsCount = root.querySelector('#results-count');
  const search = root.querySelector('#review-search');
  const rating = root.querySelector('#rating-filter');
  const sort = root.querySelector('#sort-filter');
  const dialog = root.querySelector('#photo-dialog');
  const dialogImage = root.querySelector('#dialog-image');
  const dialogPrev = root.querySelector('#dialog-prev');
  const dialogNext = root.querySelector('#dialog-next');
  const initialCount = parseInt(root.dataset.initialCount, 10) || 18;
  const loadIncrement = parseInt(root.dataset.loadIncrement, 10) || 18;
  let filter = 'all';
  let visible = initialCount;
  let gallery = [];
  let imageIndex = 0;

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const initials = name => !name || name.toLowerCase() === 'anonymous' ? 'A' : name.split(/\s+/).slice(0,2).map(part => part[0]).join('').toUpperCase();
  const formatDate = value => value ? new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(value + 'T00:00:00Z')) : '';
  const compatibleImages = images => images.filter(src => !/\.heic(?:$|\?)/i.test(src));

  const showImage = () => {
    dialogImage.src = gallery[imageIndex];
    const multiple = gallery.length > 1;
    dialogPrev.hidden = !multiple;
    dialogNext.hidden = !multiple;
  };
  const openGallery = (images, index = 0) => {
    gallery = compatibleImages(images);
    if (!gallery.length) return;
    imageIndex = Math.min(index, gallery.length - 1);
    showImage();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else window.open(gallery[imageIndex], '_blank', 'noopener');
  };

  const selectWallReviews = () => {
    const candidates = reviews.filter(review =>
      review.productUrl && /^https?:\/\//i.test(review.productUrl) &&
      review.rating >= 4 && (review.review || '').trim().length >= 45 &&
      compatibleImages(review.images || []).length
    ).sort((a,b) => b.date.localeCompare(a.date));
    const selected = [];
    const seenIds = new Set();
    const seenImages = new Set();
    const seenAuthors = new Set();
    const addCandidates = preferUniqueAuthors => {
      candidates.forEach(review => {
        if (selected.length >= 12 || seenIds.has(review.id)) return;
        const images = compatibleImages(review.images || []);
        const featuredImage = images.find(image => !seenImages.has(image));
        const authorKey = (review.author || 'Anonymous').trim().toLowerCase();
        if (!featuredImage || (preferUniqueAuthors && seenAuthors.has(authorKey))) return;
        selected.push({...review, featuredImage});
        seenIds.add(review.id); seenImages.add(featuredImage); seenAuthors.add(authorKey);
      });
    };
    addCandidates(true);
    addCandidates(false);
    return selected.slice(0,12);
  };

  const renderWall = () => {
    const wallReviews = selectWallReviews();
    const cards = wallReviews.map((review,index) => {
      const card = el('article','wall-card');
      card.dataset.reviewId = review.id;
      const photo = el('button','wall-photo');
      photo.type = 'button'; photo.setAttribute('aria-label','Open customer photo from ' + review.author);
      const image = el('img'); image.src = review.featuredImage; image.alt = 'Customer-submitted photo for ' + (review.product || 'reviewed product');
      image.loading = index < 5 ? 'eager' : 'lazy';
      if (index < 3) image.fetchPriority = 'high';
      image.onerror = () => card.remove();
      photo.append(image,el('span','photo-label','Customer photo'));
      photo.addEventListener('click',() => openGallery(review.images || []));

      const copy = el('div','wall-copy');
      const stars = el('div','wall-stars','★'.repeat(review.rating) + '☆'.repeat(5-review.rating));
      stars.setAttribute('aria-label',review.rating + ' out of 5 stars');
      const quote = el('p','wall-review','“' + review.review.trim() + '”');
      const byline = el('span','wall-byline',review.author + (review.date ? ' · ' + formatDate(review.date) : ''));
      const product = el('a','wall-product'); product.href = review.productUrl;
      product.append(el('span','',review.product ? 'View ' + review.product : 'View reviewed product'),el('span','','→'));
      copy.append(stars,quote,byline,product);
      card.append(photo,copy);
      return card;
    });
    featuredWall.replaceChildren(...cards);
  };

  const createMedia = review => {
    if (!review.images.length) return null;
    const images = compatibleImages(review.images);
    if (!images.length) {
      const link = el('a','review-media','Open customer photo');
      link.href = review.images[0]; link.target = '_blank'; link.rel = 'noopener';
      link.style.padding = '34px'; link.style.textAlign = 'center';
      return link;
    }
    const button = el('button','review-media');
    button.type = 'button'; button.setAttribute('aria-label','Open customer photo');
    const image = el('img'); image.src = images[0]; image.loading = 'lazy';
    image.alt = review.product ? 'Customer-submitted photo for ' + review.product : 'Customer-submitted photo';
    image.onerror = () => button.remove();
    button.append(image);
    if (images.length > 1) button.append(el('span','media-count','+' + (images.length - 1) + ' more'));
    button.addEventListener('click',() => openGallery(images));
    return button;
  };

  const createCard = review => {
    const card = el('article','review-card');
    card.dataset.reviewId = review.id;
    const media = createMedia(review); if (media) card.append(media);
    const body = el('div','review-body');
    const top = el('div','review-top');
    const stars = el('div','stars','★'.repeat(review.rating) + '☆'.repeat(5-review.rating));
    stars.setAttribute('aria-label',review.rating + ' out of 5 stars');
    top.append(stars,el('span','review-type',review.type === 'product' ? 'Product review' : 'Company review'));
    body.append(top);
    if (review.title) body.append(el('h3','review-title',review.title));
    const reviewText = review.review || 'Rating submitted without a written comment.';
    const text = el('p',review.review ? 'review-text' : 'review-text empty',reviewText);
    if ((review.review || '').length > 360) {
      text.classList.add('collapsed');
      const toggle = el('button','read-more','Read full review'); toggle.type = 'button';
      toggle.addEventListener('click',() => { const collapsed = text.classList.toggle('collapsed'); toggle.textContent = collapsed ? 'Read full review' : 'Show less'; });
      body.append(text,toggle);
    } else body.append(text);
    const reviewer = el('div','reviewer'); reviewer.append(el('span','avatar',initials(review.author)));
    const copy = el('span','reviewer-copy'); copy.append(el('strong','',review.author),el('span','',[formatDate(review.date),review.location].filter(Boolean).join(' · '))); reviewer.append(copy);
    if (review.verified) reviewer.append(el('span','verified','✓ Verified customer'));
    body.append(reviewer);
    if (review.productUrl) {
      const product = el('a','product-link'); product.href = review.productUrl; product.append(el('span','',review.product || 'View reviewed product'),el('b','','→')); body.append(product);
    }
    card.append(body); return card;
  };

  const filtered = () => {
    const query = search.value.trim().toLowerCase();
    return reviews.filter(review => {
      const typeMatch = filter === 'all' || review.type === filter || (filter === 'photos' && review.images.length);
      const ratingMatch = rating.value === 'all' || String(review.rating) === rating.value;
      const content = [review.review,review.title,review.author,review.product,review.location].join(' ').toLowerCase();
      return typeMatch && ratingMatch && (!query || content.includes(query));
    }).sort((a,b) => {
      if (sort.value === 'highest') return b.rating-a.rating || b.date.localeCompare(a.date);
      if (sort.value === 'lowest') return a.rating-b.rating || b.date.localeCompare(a.date);
      return b.date.localeCompare(a.date);
    });
  };
  const render = () => {
    const all = filtered(); const shown = all.slice(0,visible);
    grid.replaceChildren(...shown.map(createCard));
    resultsCount.textContent = all.length ? 'Showing ' + shown.length + ' of ' + all.length + ' reviews' : 'No reviews found';
    empty.style.display = all.length ? 'none' : 'block';
    loadMore.parentElement.style.display = visible < all.length ? 'flex' : 'none';
  };

  root.querySelectorAll('.filter-chip').forEach(button => button.addEventListener('click',() => {
    filter = button.dataset.filter; visible = initialCount;
    root.querySelectorAll('.filter-chip').forEach(item => item.setAttribute('aria-pressed',String(item === button))); render();
  }));
  search.addEventListener('input',() => { visible=initialCount; render(); });
  rating.addEventListener('change',() => { visible=initialCount; render(); });
  sort.addEventListener('change',render);
  loadMore.addEventListener('click',() => { visible += loadIncrement; render(); });
  root.querySelector('#dialog-close').addEventListener('click',() => dialog.close());
  dialogPrev.addEventListener('click',() => { imageIndex=(imageIndex-1+gallery.length)%gallery.length; showImage(); });
  dialogNext.addEventListener('click',() => { imageIndex=(imageIndex+1)%gallery.length; showImage(); });
  dialog.addEventListener('click',event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown',event => { if(event.key==='ArrowLeft'&&gallery.length>1)dialogPrev.click(); if(event.key==='ArrowRight'&&gallery.length>1)dialogNext.click(); });
  renderWall();
  render();
})();
